import React, { Component } from 'react';
import { Drawer as OriginDrawer } from "@tinper/next-ui";

require('./index.less');

class Drawer extends Component {
    render() { 
        return <OriginDrawer 
            {...this.props} 			
        />;
    }
}
export default Drawer;
